var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-widget"},[_c('div',{staticClass:"c-widget__header"},[_c('span',{staticClass:"handle mr-4"},[_vm._v("::")]),_vm._v(_vm._s(_vm.label)+" "),_c('div',{staticClass:"c-widget__header-controls"},[_vm._t("pin"),_vm._t("remove")],2)]),_c('div',{staticClass:"c-widget__content"},[_vm._v(" LIST ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }